import React from 'react';
import Skeleton from 'react-loading-skeleton';
import AppHeader from './AppHeader';

const SidebarLoadingSkeleton = () => {
	const n = 8;
	const array = [...Array(n)].map((e, i) => {
		return (
			<div id={`listItemPlaceholder-${i}`} key={`listItemPlaceholder-${i}`} className="properties-list__list-item-wrapper">
				<div className="properties-list__list-item">
					<div className="list-item__home-image-wrapper">
						<Skeleton style={{ height: '100%', width: '100%', lineHeight: 2 }}  />
					</div>
					<div className="list-item__important-details">
						<div className="row g-0 px-3">
							<div className="d-flex align-items-center pt-1">
								<Skeleton width={186} height={33} className='mb-1' />
							</div>
							<div className="mb-1">
								<Skeleton width={168} height={20} inline />
							</div>
							<Skeleton width={148} height={14} inline />
						</div>
						<div className="d-flex justify-content-between w-100 pb-1 px-3">
							<Skeleton width={50} height={16} />
							<div className="list-item__vertical-rule--small" />
							<Skeleton width={50} height={16} />
							<div className="list-item__vertical-rule--small" />
							<Skeleton width={50} height={16} />
							<div className="list-item__vertical-rule--small" />
							<Skeleton width={50} height={16} />
							<div className="list-item__vertical-rule--small" />
						</div>
					</div>
				</div>
			</div>
		);
	});

	return (
		<div
			id="propertiesList"
			className="properties-list__wrapper row g-0 justify-content-center align-content-start pb-5"
		>
			<div className="d-flex flex-lg-wrap flex-xl-nowrap w-100 justify-content-between justify-content-lg-center justify-content-xl-between align-items-center py-3 px-4">
				<AppHeader />
				<div className="small text-center flex-shrink-0 mt-lg-1 mt-xl-0">
					Loading properties...
				</div>
			</div>
			<div className="properties-list__wrapper d-flex flex-wrap overflow-hidden shadow-none justify-content-center">
				{[array]}
			</div>
		</div>
	);
};

export default SidebarLoadingSkeleton;
